import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import ShortInfo from 'src/components/user/ShortInfo';
import { BASE_ICONS } from 'src/components/svg';

import { withRouter, remCss, addressObject, permissions } from 'src/helpers';

import model from './model';
import { TableLibrary } from 'src/components/complex';
import { MCButton, ToggleSwitch } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';

class ManagerLocations extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    model.detail(this.props.router.params.id, (err) => err && this.back());
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  componentDidUpdate(prevProps) {
    if (this.props.router.params?.id !== prevProps.router.params?.id) {
      model.detail(this.props.router.params.id);
    }
  }

  renderList = () => {
    const { manager = {} } = model.state;
    let loading = model.refreshing();
    let noResults = model.noResults();
    let items = model.items();
    let { total = 0, ...createState } = model.getCurrent();

    let canEdit = permissions.ACTIONS.SETTING_MANAGER_EDIT_BUTTON.checkActive({
      auth: model.state?.user
    });

    return (
      <TableLibrary
        loading={loading}
        noResults={noResults}
        searchQuery={''}
        sortBy={model.state.sortBy}
        selectedPage={model.state.pageIndex}
        total={total}
        limit={model.listLimit}
        onSortChange={(sortBy) => {
          model.handleChange('sortBy', sortBy);
          model.setListState({ items: [] }, model.getCurrentId(), null, true);
          model.loadMore();
        }}
        onSetPage={(v) => {
          model.handleChange('pageIndex', v);
          model.setListState({ items: [] }, model.getCurrentId(), null, true);
          model.loadMore();
        }}
        columns={[
          {
            label: '#',
            resize: true,
            width: '5%',
            renderCell: (item, i) => model.listLimit * model.state.pageIndex + i + 1
          },
          {
            label: LANG_CONST.name,
            resize: true,
            renderCell: (item) => {
              return item.hospital?.split('_')[0];
            }
          },
          {
            label: LANG_CONST.address.address,
            resize: true,
            renderCell: (item) => {
              return addressObject({ cityAddress: item.city }).fullAddressNameReverse;
            }
          },
          ...Object.keys(LANG_CONST.constants.manager_access).map((value) => ({
            label: LANG_CONST.constants.manager_access[value],
            resize: true,
            minWidth: '120',
            width: '15%',
            renderCell: (item) => {
              if (!manager) return null;
              const access = manager.managerAccess?.find((a) => a.hospitalId === item.id);
              const updating = model.state.updating;
              const isActive =
                updating[item.id] && updating[item.id][value] !== undefined
                  ? updating[item.id][value]
                  : !!(access && access[value]);

              return (
                <ToggleSwitch
                  className={!manager.managerActive ? 'disabled' : ''}
                  disabled={
                    !canEdit ||
                    createState.loading ||
                    model.getApiState('edit').loading ||
                    !manager.managerActive ||
                    manager.id === model.state.user?.id
                  }
                  checked={isActive}
                  onChange={() => model.access(item, value, !isActive)}
                />
              );
            }
          }))
        ]}
        data={items}
      />
    );
  };

  render() {
    const { manager } = model.state;

    return (
      <div className={'mc-container-content mc-patient'}>
        <div className={'mc-container-content__header mc-flex-20'}>
          <MCButton
            width={40}
            iconname={BASE_ICONS.BACK_ARROW}
            primary
            circle
            dark
            onClick={this.back}
          />
          {manager && <ShortInfo user={manager} description={manager.email} />}
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            {this.renderList()}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ManagerLocations);
